<mc-full-navbar></mc-full-navbar>

<main class="mc-page mc-page-full mc-page-centered mc-brand-gradient">
  <router-outlet></router-outlet>
</main>
